import type { Facts, ReasonCode, Remedy, Requirement } from "../types";

/** a requirement from its parts; every builder goes through here */
export function requirement<R = unknown>(
  id: string,
  reason: ReasonCode,
  test: (facts: Facts, resource: R) => boolean,
  remedy?: Remedy,
): Requirement<R> {
  return { id, reason, test, remedy, withRemedy: (next) => requirement(id, reason, test, next) };
}
